<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="create-invoice">
    <div class="invoice-outer">
        <form [formGroup]="itemForm">

            <div class="common-heading">
                <h5>Invoice</h5>
                <div class="billing-information">
                    <div class="bill-infoinner"></div>
                    <div class="masic-infomain">   
                        <div class="biiling-details">
                            <div class="basic-info">
                                <h4>Invoice Information</h4>
                                <div class="common-label">
                                    <label for="parkingLotId">Parking Lot <span class="custom-star">*</span></label>
                                    <div class="common-dropdown">
                                        <div class="filter-parking">
                                            <p-dropdown id="parkingLotId" placeholder="Select Parking Lot" [options]="parkingLots"
                                                optionLabel="name" optionValue="id" formControlName="parkingLotId"
                                                (onChange)="getParkingDetailById($event.value)">
                                            </p-dropdown>
                                            <img src="assets/images/fill-dropdown.svg" alt=""/>
                                            <div
                                                *ngIf="itemForm.get('parkingLotId')?.hasError('required') && (itemForm.get('parkingLotId')?.dirty || itemForm.get('parkingLotId')?.touched)">
                                                <div class="validation-error">Field is required*</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="basic-details">
                                <div class="inparking-outer">
                                    <img [src]="parkingDetail?.companyLogo || dummy" alt="Compamy logo"/>
                                    <div class="parking-text">
                                        <p><span class="address-name">Parking</span><span>-</span> <span
                                                class="custom-address">{{parkingDetail?.name || ''}}</span></p>
                                        <p><span class="address-name">Address</span><span>-</span> <span
                                                class="custom-address"> {{parkingDetail?.location?.address ||
                                                ''}}</span></p>
                                    </div>
                                </div>
                                <div class="inparking-outer parking-email">
                                    <div class="parking-text">
                                        <p><span class="address-name">Email</span><span>-</span> <span
                                                class="custom-address">{{parkingDetail?.owner?.email || ''}}</span> </p>
                                        <p class="phn-number"><span class="address-name">Mobile
                                                Number</span><span>-</span><span class="custom-address">
                                                {{parkingDetail?.owner?.mobileNumber || ''}}</span> </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>   

            <div class="driverto-outer">
                <div class="basic-outer">
                    <div class="basic-info">
                        <h4>Invoice To:</h4>
                    </div>
                    <div class="invoice-input">

<div class="common-label">
                            <label for="email">Email </label>
                            <div class="common-dropdown">
                                <div class="filter-parking">
                                    <p-autoComplete id="email" formControlName="email"  [readonly]="!!driverEmailIdReadOnly" [suggestions]="filteredemail" [size]="30"
                                        [minLength]="1" placeholder="Enter Email" (completeMethod)="findEmail($event)"
                                        [dropdown]="false" (onSelect)="onSelectionChange($event)"
                                        (input)="onInputChange($event)" emptyMessage="No User Found">
                                        <ng-template let-email pTemplate="item">
                                            <ul class="filter-search">
                                                <li class="location-label">
                                                    <div class="locationbold">
                                                        <h5>{{ email.email }}</h5>
                                                    </div>
                                                </li>
                                            </ul>
                                        </ng-template>
                                    </p-autoComplete>

                                </div>
                            </div>
                            <div
                                *ngIf="itemForm.get('email')?.hasError('required') && (itemForm.get('email')?.dirty || itemForm.get('email')?.touched)">
                                <div class="validation-error">Field is required*</div>
                            </div>
                        </div>
                        <div class="common-label country-code mobile-number">
                            <label for="phoneNumber">Mobile Number </label>
                            <div class="common-dropdown1">
                                <ngx-intl-tel-input id="phoneNumber" [cssClass]="'custom'" [preferredCountries]="preferredCountries"
                                    [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                                    [searchCountryField]="[searchCountryField.Iso2, searchCountryField.Name]"
                                    [selectFirstCountry]="false" [selectedCountryISO]="countryISO" [maxLength]="10"
                                    [phoneValidation]="true" [separateDialCode]="separateDialCode" 
                                    [numberFormat]="phoneNumberFormat.National" name="phoneNumber" customPlaceholder="Enter Mobile Number"
                                    formControlName="phoneNumber" (input)="onMobileTyping($event)" (focusout)="validatePhoneNumber()"></ngx-intl-tel-input>
                                    
                                <div
                                    *ngIf="!itemForm.get('phoneNumber').hasError('required') && itemForm.get('phoneNumber').touched && itemForm.get('phoneNumber').invalid">
                                    <small class="validation-error">Mobile number is not valid*</small>
                                </div>
                                
                            </div>
                        </div>
                        <div class="common-label">
                            <label for="name">Name <span class="custom-star">*</span></label>
                            <div class="common-dropdown">
                                <div class="filter-parking disable-input">
                                    <input id="name" class="no-focus" type="text" formControlName="name" pInputText
                                        placeholder="Enter Name" [readonly]="true" />
                                </div>
                            </div>
                        </div>
                        
                        <div class="common-label">
                            <label for="address">Address </label>
                            <div class="common-dropdown">
                                <div class="filter-parking">
                                    <input id="address" type="text" formControlName="address" pInputText [maxlength]="120"
                                        placeholder="Enter Address" />
                                </div>
                            </div>
                        </div>
                        <div class="common-label">
                            <label for="billingDate">Invoice Date <span class="custom-star">*</span></label>
                            <div class="common-dropdown">
                                <div class="common-datepicker">
                                    <p-calendar id="billingDate" #billingDate formControlName="billingDate"
                                        dateFormat="M dd, yy" placeholder="Invoice Date" [monthNavigator]="true"
                                        [yearNavigator]="true" [maxDate]="maxDate">
                                    </p-calendar>
                                    <div
                                        *ngIf="itemForm.get('billingDate')?.hasError('required') && (itemForm.get('billingDate')?.dirty || itemForm.get('billingDate')?.touched)">
                                        <div class="validation-error">Field is required*</div>
                                    </div>
                                    <img [calendarOpener]="billingDate" style="top :13px"
                                        src="assets/images/date-calender.png" alt="calender"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="parking-bg">
                    <div class="invoice-checkbox">
                        <p-checkbox [binary]="true" id="toggleShow"  (onChange)="toggleShow()"  />
                        <label for="toggleShow"> Is this invoice related to parking? </label>
                    </div> 
                   <div *ngIf="isShow" class="invoice-input">

                        <div class="common-label">
                            <label for="arrivalDate">Arrival Date & Time <span class="custom-star" *ngIf="isShow">*</span></label>
                            <div class="common-dropdown">
                                <div class="common-datepicker">
                                    <p-calendar id="arrivalDate" #arrivaldate formControlName="arrivalDate"
                                        dateFormat="M dd, yy" placeholder="Select Date & Time"
                                        (onFocus)="setDefaultDateMinutes($event,'arrivalDate')"
                                        (onSelect)="setDefaultDateMinutes($event,'arrivalDate')"
                                        [readonlyInput]="true"
                                       [showTime]="true" (onSelect)="onArrivalDateSelect($event)">
                                    </p-calendar>
                                    <div
                                    *ngIf="itemForm.get('arrivalDate')?.hasError('required') && (itemForm.get('arrivalDate')?.dirty || itemForm.get('arrivalDate')?.touched)">
                                    <div class="validation-error">Field is required*</div>
                                </div>
                                    <img [calendarOpener]="arrivaldate" style="top :13px"
                                        src="assets/images/date-calender.png" alt="calender"/>
                                </div>
                            </div>
                        </div>
                        <div class="common-label">
                            <label for="departureDate">Departure Date & Time <span class="custom-star" *ngIf="isShow">*</span></label>
                            <div class="common-dropdown">
                                <div class="common-datepicker">
                                    <p-calendar id="departureDate" #departureDate formControlName="departureDate"
                                        dateFormat="M dd, yy" placeholder="Select Date & Time" 
                                         [showTime]="true"
                                         [readonlyInput]="true"
                                         (onFocus)="setDefaultDateMinutes($event,'departureDate')"
                                          [minDate]="minDepartureDate">
                                    </p-calendar>
                                    <div
                                    *ngIf="itemForm.get('departureDate')?.hasError('required') && (itemForm.get('departureDate')?.dirty || itemForm.get('departureDate')?.touched)">
                                    <div class="validation-error">Field is required*</div>
                                </div>
                                    <img [calendarOpener]="departureDate" style="top :13px"
                                        src="assets/images/date-calender.png" alt="calender"/>
                                </div>
                            </div>
                        </div>
</div>
                </div>

                <div class="item-outer">
                    <div class="basic-infos">
                        <h4>Items</h4>
                        <div class="total-amount">
                            Total: ${{ overallTotal}}
                        </div>
                    </div>
                    <div class="custom-table">
                        <div class="table-heading">
                            <h5 class="description-text">Description <span class="custom-star">*</span></h5>
                            <h5>Base Amount ($) <span class="custom-star">*</span></h5>
                            <h5>Taxes ($) </h5>
                            <h5>Fees ($) </h5>
                        </div>
                    </div>
                    <div class="item-scroll">
                        <div formArrayName="parkingLotInvoiceItems">
                            <div *ngFor="let item of parkingLotInvoiceItems.controls; let i = index" [formGroupName]="i"
                                class="table-td">
                                <div class="table-input">
                                    <div class="common-dropdown">
                                        <div class="filter-parking">
                                            <input type="text" formControlName="itemName" pInputText
                                                placeholder="Enter description" [maxlength]="120" />
                                            <div
                                                *ngIf="item.get('itemName')?.hasError('required') && (item.get('itemName')?.dirty || item.get('itemName')?.touched)">
                                                <div class="validation-error">Field is required*</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="table-input">
                                    <div class="common-dropdown">
                                        <div class="filter-parking">
                                            <input formControlName="baseAmount" pInputText
                                                placeholder="Enter base amount" (blur)="calculateTotalAmount(i)"  (keypress)="validateNumberInput($event, 6, true)"
                                              />
                                            <div
                                                *ngIf="item.get('baseAmount')?.hasError('required') && (item.get('baseAmount')?.dirty || item.get('baseAmount')?.touched)">
                                                <div class="validation-error">Field is required*</div>
                                            </div>
                                            <div
                                                *ngIf="item.get('baseAmount')?.hasError('lessThanZero') && (item.get('baseAmount')?.dirty || item.get('baseAmount')?.touched)">
                                                <div *ngIf="!item.get('baseAmount')?.hasError('required')"
                                                    class="validation-error">Value must be greater than zero</div>
                                            </div>
                                            <div *ngIf="item.get('baseAmount')?.hasError('pattern') && (item.get('baseAmount')?.dirty || item.get('baseAmount')?.touched)">
                                                <div class="validation-error">
                                                    Valid format is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="table-input">
                                    <div class="common-dropdown">
                                        <div class="filter-parking">
                                            <input formControlName="taxPercent" pInputText
                                                placeholder="Enter taxes" 
                                                (blur)="calculateTotalAmount(i)"
                                                (keypress)="validateNumberInput($event,5, true)" (input)="limitInputLength('taxPercent')"/>
                                                <div *ngIf="item.get('taxPercent')?.hasError('pattern') && (item.get('taxPercent')?.dirty || item.get('taxPercent')?.touched)">
                                                    <div class="validation-error">
                                                        Valid format is required.
                                                    </div>
                                                </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-input">
                                    <div class="common-dropdown">
                                        <div class="filter-parking">
                                            <input formControlName="feesPercent" pInputText
                                                placeholder="Enter fees" (blur)="calculateTotalAmount(i)" (input)="limitInputLength('feesPercent')"
                                                (keypress)="validateNumberInput($event,5, true)" />
                                                <div *ngIf="item.get('feesPercent')?.hasError('pattern') && (item.get('feesPercent')?.dirty || item.get('feesPercent')?.touched)">
                                                    <div class="validation-error">
                                                        Valid format is required.
                                                    </div>
                                                </div>
                                        </div>
                                    </div>
                                </div>
                                <div style="display: none;" class="table-input">
                                    <div class="common-icon">
                                        <div class="common-dropdown">
                                            <div class="filter-parking disable-input">
                                                <input type="text" formControlName="totalAmount" pInputText
                                                    [readonly]="true" class="no-focus" placeholder="0.00" />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="gen-outer">
                        <div class="main-payment">
                            <div class="payment-status">
                                <h4>Payment Status <span class="custom-star">*</span></h4>

                            </div>
                            <div class="pending-paid">
                                <div class="payment-padding" (click)="setInvoicePaymentStatus(0)">
                                    <div class="radio-btn">
                                        <p-radioButton formControlName="invoicePaymentStatus"  [value]='0' />
                                        <h4>Pending Payment</h4>
                                    </div>
                                    <p>You have not received the<br />
                                        payment yet.</p>
                                </div>
                                <div class="payment-padding" (click)="setInvoicePaymentStatus(1)">
                                    <div class="radio-btn">
                                        <p-radioButton formControlName="invoicePaymentStatus"  [value]='1'/>
                                        <h4>Already Paid</h4>
                                    </div>
                                    <p>You have received the<br />
                                        payment.</p>
                                    </div>
                            </div>
                            <div
                            *ngIf="itemForm.get('invoicePaymentStatus')?.hasError('required') && (itemForm.get('invoicePaymentStatus')?.dirty || itemForm.get('invoicePaymentStatus')?.touched)">
                            <div class="validation-error">Field is required*</div>
                        </div>
                        </div>

                        <div class="gen-btn">
                            <div class="radio-text" (click)="shareInvoice()">
                                <p-checkbox id="invoicebox" name="invoice" value="is"></p-checkbox>
                                <label for="invoicebox">
                                    Please forward this invoice to the given email and mobile number.
                                </label>
                            </div>
                            <div class="gen-btnouter">
                                <p-button label="Generate" (onClick)="generateInvoice()"></p-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>